import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PolicyDetailsService } from '../services/policydetails.service';
import { MyCustomersSearchHandler } from './my-customers-search.handler';

@Component({
  selector: 'sym-my-customers-search',
  templateUrl: './my-customers-search.component.html',
  styleUrls: ['./my-customers-search.component.scss'],
})
export class MyCustomersSearchComponent extends MyCustomersSearchHandler implements OnInit {
  constructor(
    public service: PolicyDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
